function hide_out_of_stock(){
	console.log('inside out of stock');
		var all_out_of_stock = 0;
		var remove_selected = 0;
		$(".is-ntcolor .swatches-select li").each(function() {
			if ($(this).hasClass('jas_soldout')) {
				if ($(this).hasClass('is-selected')){
					$(this).removeClass('is-selected');
					remove_selected = 1;
				}
			} else {
				all_out_of_stock = 1;
			}
			$('.is-ntcolor .swatches-select .image-swatch').css('display','block ');
		});
				if(all_out_of_stock == 1){
			$('.is-ntcolor .swatches-select .jas_soldout').css('display','none');
		}
	  
	  if(remove_selected == 1){
		$(".is-ntcolor .swatches-select li").each(function() {
			if ($(this).hasClass('jas_soldout')) {
				
			} else {
				$(this).addClass('is-selected');
				return false;
			}
		});
	  }
	
}
$(document).ready(function(){ 
$('.variations .nt_select_pr_0 .swatches-select .gecko-swatch').click(function(){
	setTimeout(function () {
		hide_out_of_stock();
	}, 500);
});
});
$(window).load(function() {
	setTimeout(function () {
		hide_out_of_stock();
	}, 500);
});
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}